import { BasicFrameConfig } from 'InternalLibrary';
import { memo } from 'react';
import BusinessInfo from '../BusinessInfo/BusinessInfo';
import classes from 'classnames';
import LogoutButton from '../LogoutButton/LogoutButton';
import styles from './MobileFooter.module.scss';

export interface MobileFooterProps {
  onLogoutButtonClick?: () => void;
  hideLogout?: boolean;
  logo?: BasicFrameConfig['logo'];
  content: {
    logout: string;
    contactPhone: string;
    contactEmail: string;
    businessHours: string;
  };
  showLogo?: boolean;
}

export const MobileFooter = memo(
  ({
    onLogoutButtonClick,
    hideLogout = false,
    content,
    logo,
    showLogo = false,
  }: MobileFooterProps) => {
    return (
      <div className={styles.footer}>
        <BusinessInfo
          className={styles['footer-hours']}
          businessHours={content.businessHours.replace(/,\s/g, '<br />')}
          contactMail={content.contactEmail}
          contactPhone={content.contactPhone}
        />

        <div
          className={classes(
            styles['footer-logout'],
            !hideLogout && styles['logout-btn-show'],
          )}
        >
          {!hideLogout && (
            <LogoutButton onClick={onLogoutButtonClick}>
              {content.logout}
            </LogoutButton>
          )}
          {showLogo && logo}
        </div>
      </div>
    );
  },
);
